import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo } from 'react';
import { createUseStyles, Modal, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../lib/Web5Context";
import BetaBadge from "../../../components/BetaBadge";
import { CopilotChat } from "./..";
import CopilotIcon from "../CopilotChat/components/CopilotIcon";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotModal');
var _ref2 = /*#__PURE__*/React.createElement(CopilotIcon, null);
var _ref3 = /*#__PURE__*/React.createElement(BetaBadge, null);
const CopilotModal = /*#__PURE__*/memo(_ref => {
  let {
    chatSetup,
    onClose,
    open,
    title
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const chatProps = useMemo(() => _objectSpread(_objectSpread({}, chatSetup), {}, {
    className: classes.chat
  }), [chatSetup, classes.chat]);
  const modalContent = useMemo(() => open ? /*#__PURE__*/React.createElement(CopilotChat, chatProps) : null, [chatProps, open]);
  const modalTitle = useMemo(() => /*#__PURE__*/React.createElement("div", {
    className: classes.titleContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.titleLogo
  }, _ref2), /*#__PURE__*/React.createElement("div", {
    className: classes.titleCopy
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Text, {
    type: "h6",
    bold: true
  }, t('label_danai_golderminute_title')), _ref3), title)), [classes.titleContainer, classes.titleLogo, classes.titleCopy, classes.title, t, title]);
  const modalProps = useMemo(() => ({
    children: modalContent,
    className: classes.root,
    height: '90%',
    width: 690,
    isOpen: open,
    onRequestClose: onClose,
    overrides: {
      content: {
        style: {
          height: '100%'
        }
      }
    },
    title: modalTitle
  }), [modalContent, classes.root, open, onClose, modalTitle]);
  return /*#__PURE__*/React.createElement(Modal, modalProps);
});
export default CopilotModal;